import React, { useState } from "react";
import { GridColumn, Grid } from "@progress/kendo-react-grid";
import { faSort } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ProcessStatus, columns } from "../../utils/constants/NonPayPeriod";
import { usDateFormat } from "../../utils";
import moment from "moment";
import AddToolTip from "../AddToolTip/AddToolTip";
import { Button } from "react-bootstrap";
import { useDeepEffect } from "../../abstracts";
import {
  downloadNonPayPeriodReport,
  downloadReportNonPayPeriod,
  getNonPayPeriodReportData,
} from "../../services";
import LoaderWrapper from "../LoaderWrapper/LoaderWrapper";
import * as fileSaver from "file-saver";

const GenerateReportTableNonPayPeriod = ({
  setPayload,
  gridData,
  setGridData,
  payload,
  isSliderOpen,
}) => {
  const [to, setTo] = useState(20);
  const [total, setTotal] = useState(0);
  const [data, setData] = useState([]);
  const [tableLoading, setTableLoading] = useState([]);

  useDeepEffect(() => {
    setTableLoading(true);
    getNonPayPeriodReportData({
      ...payload,
      order: payload.order ? 1 : 0,
    }).then((response) => {
      if (response) {
        if (payload.from !== 0) {
          setGridData((prev) => [...prev, ...response.nonPayPeriodReportData]);
          setTotal(response.nonPayPeriodReportData.length);
          setTableLoading(false);
        } else {
          setGridData([...response.nonPayPeriodReportData]);
          setTotal(response.nonPayPeriodReportData.length);
          setTableLoading(false);
        }
      }
    });
    setTableLoading(false);
  }, [payload, isSliderOpen]);
  const downloadReport = (data1) => {
    downloadReportNonPayPeriod(
      data1.rkPlanNumber,
      data1.allocationSource,
      data1.reportId
    )
      .then((response) => {
        var blob = new Blob([response], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        fileSaver.saveAs(
          blob,
          `${data1.rkPlanNumber}_${data1.allocationSource}_${data1.reportId}Allocation Report.xlsx`
        );
      })
      .catch((error) => {});
  };
  const nonPayPeriodreportDownload = (data2) => {
    downloadNonPayPeriodReport(
      data2?.rkPlanNumber,
      data2?.allocationSource,
      data2?.reportId
    )
      .then((response) => {
        const blob = new Blob([response], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        fileSaver.saveAs(
          blob,
          `${data2.rkPlanNumber}_${data2.allocationSource}_${data2.reportId}_Allocation Upload.xlsx`
        );
      })
      .catch((error) => {});
  };
  const scrollHandler = (event) => {
    const e = event.nativeEvent;
    if (
      e.target.scrollTop + 10 >=
        e.target.scrollHeight - e.target.clientHeight &&
      total >= 20
    ) {
      setTo(to + 20);
      setPayload((prevPayload) => ({
        ...prevPayload,
        from: prevPayload.from + 20,
      }));
    }
  };
  return (
    <div>
      <div className=" mt-3 nonPayPeriodGrid alternativeColor">
        <div className="mb-10">
          <span className="fw-500">
            {gridData?.length < 10 ? `0${gridData?.length}` : gridData?.length}{" "}
          </span>
          <span className="company-associated-plans-color">
            - Record(s) found
          </span>
        </div>

        <LoaderWrapper isLoading={tableLoading}>
          <Grid
            data={gridData}
            sortable={true}
            fixedScroll={true}
            onScroll={scrollHandler}
            style={{ height: "50vh" }}
          >
            {columns.map((item, index) => (
              <GridColumn
                key={index}
                field={item.columnName}
                title={
                  <div className="d-flex">
                    <div className="ft-14 fw-600">{item.label}</div>
                    {item.columnName == "reportGenerationDate" && (
                      <FontAwesomeIcon
                        className="ml-2 mt-1 grey-text"
                        icon={faSort}
                        onClick={() => {
                          setTo(20);
                          setPayload({
                            ...payload,
                            from: 0,
                            order: !payload.order,
                          });
                        }}
                      />
                    )}
                  </div>
                }
                width={item.width}
                cell={(props) => {
                  if (item.columnName === "reportGenerationDate") {
                    return (
                      <td>
                        {usDateFormat(moment(props.dataItem[item.columnName]))}{" "}
                        {moment(
                          new Date(props.dataItem[item.columnName])
                        ).format("hh:mm A")}{" "}
                      </td>
                    );
                  } else if (item.columnName === "reportStatus") {
                    return (
                      <td>{ProcessStatus(props.dataItem[item.columnName])}</td>
                    );
                  } else if (
                    item.columnName === "allocationSource" ||
                    item.columnName === "companyName"
                  ) {
                    return (
                      <td>
                        {
                          <AddToolTip name={props.dataItem[item.columnName]}>
                            {props.dataItem[item.columnName]}
                          </AddToolTip>
                        }
                      </td>
                    );
                  } else if (item.columnName === "action") {
                    return (
                      <div className="d-flex flex-column download-npayPeriod">
                        <div>
                          <Button
                            variant="link pl-2"
                            disabled={props.dataItem.reportStatus !== 2}
                            className="mt-3"
                            onClick={() => {
                              downloadReport(props.dataItem);
                            }}
                          >
                            Download Report
                          </Button>
                        </div>
                        <div>
                          <Button
                            variant="link pl-2"
                            disabled={props.dataItem.reportStatus !== 2}
                            onClick={() =>
                              nonPayPeriodreportDownload(props.dataItem)
                            }
                          >
                            Generate Payroll File
                          </Button>
                        </div>
                      </div>
                    );
                  } else {
                    return (
                      <td className="black-text fs-14 fw-500">
                        {props.dataItem[item.columnName]}
                      </td>
                    );
                  }
                }}
              />
            ))}
          </Grid>
        </LoaderWrapper>
      </div>
    </div>
  );
};

export default GenerateReportTableNonPayPeriod;
